import { getSeq } from "../../../../../helpers/get-seq";
import logo from "../../../../assets/images/landing-page/asin.png";
import { Separator } from "../../../utils/landing-page/separator";
import "./index.scss";

export function FooterSection() {
  const footerLinks = [
    { text: "Politique de confidentialité", href: "/politique-confidentialite" },
    { text: "Mentions légales", href: "/mentions-legales" },
  ];

  return (
    <footer className="FooterSection">
      <div className="FooterSection-backgroundEffects">
        <div className="FooterSection-blueEffect" />
        <div className="FooterSection-purpleEffect" style={{ animationDelay: "2s" }} />
      </div>

      <div className="FooterSection-container">
        <div className="FooterSection-mainContent">
          <div className="FooterSection-logoSection">
            <img className="FooterSection-logo" alt="ASIN Logo" src={logo} />
          </div>

          <div>
            <p className="FooterSection-description" />
          </div>
        </div>

        <Separator className="FooterSection-separator" />

        <div className="FooterSection-bottomContent">
          <div className="FooterSection-copyrightText">© 2025 ASIN. Tous droits réservés.</div>

          <div className="FooterSection-linksSection">
            {footerLinks.map((link, index) => (
              <a
                key={`landing-page-footerlink-${getSeq()}-${index}`}
                href={link.href}
                className="FooterSection-link"
              >
                {link.text}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
